<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Details && !Delete_Details">Add Features</v-flex>
                    <v-flex v-else-if="Update_Details">Update Features</v-flex>
                    <v-flex v-else-if="Delete_Details">Delete Features</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text v-if="!Update_Details && !Delete_Details">
                    <v-flex wrap style="padding: 10px;">
                        <v-flex>                                                    
                            <v-select item-value='_id' item-text='name' return-object v-model="SelectedCourseDetail" :items="GetCourseDetailList" label="Select Course Title">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Course_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Course_Title }}    
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex>
                            <v-text-field label="Feature Title" v-model="Feature_Title"></v-text-field>
                        </v-flex>
                        <v-flex>
                            <v-flex style="font-size: 14px;font-weight: 400;padding-bottom: 10px">Feature Description :</v-flex>
                            <vue-editor v-model="Feature_Description"></vue-editor>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else-if="Update_Details">
                    <v-flex>
                        <v-flex style="font-weight:bold;padding-bottom: 10px;">Course : {{ Current_Course.Course_Title }}</v-flex>
                    </v-flex>
                    <v-layout row>
                        <v-select item-value='Feature_Id' item-text='name' return-object @change="SelectedFeature" v-model="Selected_Feature" :items="Course_Features" label="Select Feature">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Feature_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Feature_Title }}    
                                </template>
                        </v-select>
                    </v-layout>
                    <v-flex>
                        <v-text-field label="Feature Title" v-model="Feature_Title"></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-flex style="font-weight:bold;padding-bottom: 10px;">Feature Description :</v-flex>
                        <vue-editor id="editor_Feature" v-model="Feature_Description"></vue-editor>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else-if="Delete_Details">                    
                     <v-flex>
                        <v-flex style="font-weight:bold;padding-bottom: 10px;">Course : {{ Current_Course.Course_Title }}</v-flex>
                    </v-flex>
                    <v-layout row>
                        <v-select item-value='Feature_Id' item-text='name' return-object @change="SelectedFeature" v-model="Selected_Feature" :items="Course_Features" label="Select Feature">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Feature_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Feature_Title }}    
                                </template>
                        </v-select>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" v-if="!Update_Details && !Delete_Details" @click="SubmitFeature">Add Feature</v-btn>
                        <v-btn color="success" v-else-if="Update_Details" @click="UpdateFeature">Update Feature</v-btn>
                        <v-btn color="success" v-else-if="Delete_Details" @click="DeleteFeature">Delete Feature</v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            SelectedCourseDetail    : {},
            Feature_Title           : "",
            Feature_Description     : "",
            Course_Features         : [],
            Selected_Feature        : {},
            Current_Course          : {},
            Update_Details          : false,
            Delete_Details          : false,
            Feature_Id              : ''
        }
    },
    computed:{
        GetCourseDetailList(){
            
            return this.$store.getters.GetCourseDetailsList
        }
    },
    methods:{
        SelectedFeature(){

            this.Feature_Id          = this.Selected_Feature['Feature_Id']
            this.Feature_Title       = this.Selected_Feature['Feature_Title']
            this.Feature_Description = this.Selected_Feature['Feature_Description']
        },
        CloseDialog(){

            this.ClearForm()
            this.$emit('close')
        },
        SubmitFeature(){

            let Feature = {}
            Feature["Course_Id"]            = this.SelectedCourseDetail["_id"]
            Feature["Feature_Title"]        = this.Feature_Title
            Feature['Feature_Description']  = this.Feature_Description

            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursefeature/addcoursefeature`,Feature)
                        .then(response =>{

                            this.$store.commit('UpdateCourseFeatures',response["data"]["response"][0])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Added Feature","Color":"green","Close": false });
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Add Feature","Color":"red","Close": false });
                        })
        },
        UpdateFeature(){

            let Feature = {}
            Feature['Course_Id']                     = this.Current_Course['Course_Id']
            Feature['Feature_Id']                    = this.Feature_Id
            Feature["update"]                        = {}
            Feature['update']['Feature_Title']       = this.Feature_Title
            Feature['update']['Feature_Description'] = this.Feature_Description
    
            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursefeature/updatecoursefeature`,Feature)
                        .then(response =>{

                            this.$store.commit('UpdateCourseFeatures',response["data"]["response"][0])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Feature","Color":"green","Close": false });
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Update Feature","Color":"red","Close": false });
                        })
        },
        DeleteFeature(){

            let data = { "Course_Feature_Id" : this.Current_Course['_id'] , "Course_Id" : this.Current_Course['Course_Id'] , "Feature_Id": this.Selected_Feature['Feature_Id'] }

            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursefeature/deletecoursefeature`,data)
                        .then(response =>{

                            this.$store.commit('UpdateCourseFeatures',response["data"]["response"][0])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Feature","Color":"green","Close": false });
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Update Feature","Color":"red","Close": false });
                        })
        },
        ClearForm(){

            this.Delete_Details = false
            this.Update_Details = false
            this.SelectedCourseDetail = {}
            this.Feature_Title        = ""
            this.Feature_Description  = ""
            this.Selected_Feature     = {}
            this.Current_Course       = {}
            this.Course_Features      = []
            this.Feature_Id           = ''
            
        },
        GetCourseDetailsList(){

            
            this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                        .then(response =>{

                            this.$store.commit('SetCourseDetailList',response["data"]["response"])
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                        })

        },
        GetFeatures(Course,Type){

            this.Current_Course  = Course
            Type == 'Update' ? this.Update_Details  = true : this.Delete_Details = true
            this.Course_Features = Course['Features']
        }   
    }
}
</script>
<style scoped>

</style>